import React, { memo } from 'react';
import type { ControlRendererProps } from '../ControlRenderer';

export const IframeViewerControl = memo((props: ControlRendererProps) => {
  const { control } = props;
  const src = (control.config?.src as string) || undefined;
  const height = (control.config?.height as number) ?? 400;
  const title = (control.config?.title as string) || control.label || control.id;
  const useSandbox = (control.config?.sandbox as boolean) ?? true;

  if (!src) {
    return <div className="af-iframe-viewer-control--empty">No URL configured</div>;
  }

  return (
    <div className="af-iframe-viewer-control" data-control-id={control.id}>
      {control.label && <p className="af-iframe-viewer-control__label">{control.label}</p>}
      <iframe
        src={src}
        title={title}
        width="100%"
        height={height}
        style={{ border: 'none' }}
        sandbox={useSandbox ? 'allow-same-origin allow-forms' : undefined}
      />
    </div>
  );
});

IframeViewerControl.displayName = 'IframeViewerControl';

export default IframeViewerControl;
